import BlogHead from 'components/Blog/BlogHead';
import BlogHero from 'components/Blog/BlogHero';
import BlogArticles from 'components/Blog/BlogArticles';
import Shell from 'components/Shell/Shell';
import StyleContextProvider from 'utils/context/StyleContextProvider';
import {
    BLOG_INDEX_BODY_LIMIT,
    BLOG_INDEX_LIMIT,
    contentfulOptions as options,
} from 'utils/constants';
import { getBlogs, getMasterControl } from '@viome/vnxt-nucleus';
import styles from './blog.module.scss';
import ErrorPage from '../404';

const BlogIndex = (props) => {
    const { preview, masterControl, page, recentBlogs } = props,
        blogIndexData = page?.content,
        topBlog = blogIndexData?.topBlog,
        featuredBlogs = blogIndexData?.featuredBlogsCollection?.items || [],
        title = blogIndexData?.title,
        subText = blogIndexData?.subText,
        categories = blogIndexData?.topicsCollection.items,
        articlesSettings = {
            limit: BLOG_INDEX_LIMIT,
        },
        excludedBlogs = [topBlog, ...featuredBlogs].map((item) => item?.slug);

    let skip = 3 - featuredBlogs.length;

    if (!topBlog) {
        skip++;
    }

    if (!page) {
        return <ErrorPage />;
    }

    return (
        <Shell
            masterControl={masterControl}
            page={page}
            preview={preview}
            className="blog viome viome3"
            isLegacy={false}
        >
            <StyleContextProvider styles={styles}>
                <BlogHead title={title} subText={subText} />
                <BlogHero
                    blog={topBlog}
                    blogs={recentBlogs}
                    featured={featuredBlogs}
                    {...articlesSettings}
                />

                {recentBlogs.length > 0 && (
                    <section className={styles.blog__Fold}>
                        <BlogHead
                            categories={categories}
                            title={title}
                            subText={subText}
                            category={{
                                slug: recentBlogs.slug,
                                title: recentBlogs.title,
                            }}
                        />
                        <BlogArticles
                            blogArticles={recentBlogs}
                            limit={BLOG_INDEX_BODY_LIMIT}
                            skip={skip}
                            preview={preview}
                            infinite
                            excludedBlogs={excludedBlogs}
                        />
                    </section>
                )}
            </StyleContextProvider>
        </Shell>
    );
};

export default BlogIndex;

export async function getStaticProps({ preview = false }) {
    const pageData = Promise.all([
            getMasterControl.get(options),
            getBlogs.getBlogIndex(options),
            getBlogs.getBlogsByDateDESC(options, 10),
        ]),
        props = await pageData.then(
            async ([
                masterControl,
                page = {},
                // topBlogs,
                recentBlogs = [],
            ]) => ({
                preview,
                masterControl,
                page,
                // topBlogs,
                recentBlogs,
            }),
        );

    if (props.recentBlogs?.blogs.length === 0) {
        return {
            notFound: true,
        };
    }

    return { props, revalidate: 1200 };
}
